// pages/P2PSuccess.tsx

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const P2PSuccess: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear any pending order data
    localStorage.removeItem('p2p_order_id');
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-4">
      <div className="text-center max-w-md w-full">
        {/* Success Icon */}
        <div className="w-24 h-24 bg-[#0ECB81] rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
          <CheckCircle2 className="w-12 h-12 text-white" />
        </div>

        <h1 className="text-3xl font-bold text-foreground mb-2">Payment Successful!</h1>
        <p className="text-muted-foreground text-base">
          Your USDC payment on Solana has been confirmed via Fuze Finance.
        </p>

        <div className="mt-6 p-4 bg-card rounded-xl border border-border">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Status</span>
            <span className="text-[#0ECB81] font-medium">● Completed</span>
          </div>
          <div className="flex items-center justify-between text-sm mt-3">
            <span className="text-muted-foreground">Provider</span>
            <span className="text-foreground font-medium flex items-center gap-1">
              <Building2 className="w-3 h-3" />
              Fuze Finance
            </span>
          </div>
          <div className="flex items-center justify-between text-sm mt-3">
            <span className="text-muted-foreground">Network</span>
            <span className="text-foreground font-medium">Solana</span>
          </div>
          <div className="flex items-center justify-between text-sm mt-3">
            <span className="text-muted-foreground">Token</span>
            <span className="text-foreground font-medium">USDC (SPL)</span>
          </div>
        </div>

        <div className="mt-6 space-y-3">
          <Button
            onClick={() => navigate('/p2p')}
            className="w-full bg-yellow-400 text-black hover:bg-yellow-500 font-semibold"
          >
            New Payment
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/dashboard')}
            className="w-full border-border text-foreground hover:bg-muted"
          >
            Go to Dashboard
          </Button>
        </div>

        <p className="text-[8px] text-muted-foreground/60 mt-1">
          Powered by Fuze Finance - Global Payments Infrastructure
        </p>
      </div>
    </div>
  );
};

export default P2PSuccess;
